import PropTypes from "prop-types";
import cn from "classnames";
import { tagular } from "@cohesion/tagular";

import { BIT_PROP_TYPES } from "@constants/best-in-travel/2025/proptypes";

import { useBestInTravel } from "@context/bestInTravel/2025/bestInTravelContext";

import { CloseX } from "@icons";
import { TOC } from "./toc";

export function DestinationsNav({ className = "", category }) {
  const { destinationsMenuOpen, setDestinationsMenuOpen, themeClasses } =
    useBestInTravel();

  return (
    <div
      className={cn(
        "fixed top-0 w-full h-screen-dvh sm:h-full overflow-hidden transition-all duration-500",
        destinationsMenuOpen ? "z-50" : "-z-10"
      )}
    >
      <div
        className={cn(
          "relative text-white sm:h-screen-dvh h-full w-full sm:bg-transparent sm:flex overflow-y-scroll no-scrollbar",
          destinationsMenuOpen ? themeClasses.background : "bg-transparent",
          className
        )}
      >
        <button
          type="button"
          className={cn(
            "fixed z-10 sm:absolute top-2 right-2 sm:top-8 sm:right-8",
            !destinationsMenuOpen && "hidden"
          )}
          onClick={() => {
            setDestinationsMenuOpen(false);
            tagular("click", {
              actionOutcome: "Close",
              outboundUrl: "null",
              webElement: {
                location: "BIT_Overview",
                elementType: "BUTTON",
                text: "X",
                position: "0",
              },
            });
          }}
        >
          <CloseX className={cn("text-md", themeClasses.text)} />
        </button>
        <div
          className={cn(
            "p-4 lg:pt-24 sm:z-10 sm:overflow-y-scroll sm:no-scrollbar sm:p-8 sm:pr-12 sm:pl-24 sm:w-1/3",
            themeClasses.background,
            "nav-left-content",
            destinationsMenuOpen ? "translate-x-0" : "-translate-x-full"
          )}
        >
          <div className="toc-wrapper">
            <TOC category={category} />
          </div>
        </div>
        <div
          className={cn(
            "fixed bottom-0 z-50 w-full h-20 px-8",
            destinationsMenuOpen && "light-opacity-overlay"
          )}
        />

        <div
          className={cn(
            "hidden sm:block sm:relative sm:w-2/3 sm:overscroll-none overflow-hidden",
            "transform transition-all duration-700 ease-in-out",
            destinationsMenuOpen ? "scale-100" : "scale-150"
          )}
        >
          <div className="w-full h-full arch-overlay" />
        </div>
        <style jsx>{`
          .arch-overlay {
            position: relative;
            overflow: hidden;
          }
          .arch-overlay::before {
            content: "";
            position: absolute;
            top: 15%;
            left: 25%;
            width: 65%;
            height: 70%;
            background: transparent;
            border-radius: 50% 50% 0 0;
            box-shadow: 0 0 0 100vw ${themeClasses.backgroundHex};
            transition:
              transform 0.4s ease-in-out,
              opacity 0.4s ease-in-out;
            transform: ${destinationsMenuOpen ? "scale(1)" : "scale(1.5)"};
            opacity: ${destinationsMenuOpen ? "1" : "0"};
            transform-origin: center;
          }
          .nav-left-content {
            transition-delay: ${destinationsMenuOpen ? "0s" : "0.7s"};
          }
          .toc-wrapper {
            transition-delay: ${destinationsMenuOpen ? "0s" : "0.7s"};
          }
          .light-opacity-overlay {
            background: linear-gradient(
              to top,
              ${themeClasses.backgroundHex},
              ${themeClasses.backgroundHex} 50%,
              transparent 100%
            );
          }
        `}</style>
      </div>
    </div>
  );
}

DestinationsNav.propTypes = {
  className: PropTypes.string,
  category: BIT_PROP_TYPES.category,
};
